const FounderSection = () => {
  const scrollToSurvey = () => {
    const element = document.querySelector("#survey");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="founder"
      data-testid="founder-section"
      className="py-20 md:py-32 bg-white overflow-hidden"
    >
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left: Video */}
          <div className="relative order-2 lg:order-1 flex justify-center">
            <div className="relative">
              {/* Background decorations */}
              <div className="absolute -inset-4 bg-gradient-to-br from-blue-100 to-blue-50 rounded-[40px] transform rotate-3" />
              <div className="absolute -inset-4 bg-gradient-to-tr from-blue-50 to-white rounded-[40px] transform -rotate-2" />
              
              {/* Video container */}
              <div className="relative bg-white rounded-[32px] shadow-2xl overflow-hidden p-3">
                <div className="rounded-[24px] overflow-hidden">
                  <iframe 
                    src="https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Freel%2F3101964210191311%2F&show_text=false&width=267&t=0" 
                    width="267" 
                    height="476" 
                    style={{ border: 'none', overflow: 'hidden' }}
                    scrolling="no" 
                    frameBorder="0" 
                    allowFullScreen={true}
                    allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                    title="Túró István bemutatkozó videó"
                    className="rounded-[24px]"
                  />
                </div>
              </div>

              {/* Floating elements */}
              <div className="absolute -top-6 -right-6 w-16 h-16 bg-yellow-400 rounded-2xl flex items-center justify-center shadow-lg animate-bounce">
                <svg className="w-8 h-8" viewBox="0 0 24 24" fill="none" stroke="#1E3A8A" strokeWidth="2">
                  <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
                </svg>
              </div>
              <div className="absolute -bottom-4 -left-4 w-14 h-14 bg-blue-900 rounded-xl flex items-center justify-center shadow-lg">
                <svg className="w-7 h-7" viewBox="0 0 24 24" fill="white">
                  <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
                </svg>
              </div>
            </div>
          </div>

          {/* Right: Content */}
          <div className="order-1 lg:order-2">
            <div className="inline-flex items-center gap-2 bg-blue-50 text-blue-900 px-4 py-2 rounded-full text-sm font-semibold mb-6">
              AZ ALAPÍTÓ
            </div>
            
            <h2
              className="text-3xl md:text-5xl font-extrabold tracking-tight text-slate-900 mb-6"
              style={{ fontFamily: "'Manrope', sans-serif" }}
            >
              Túró István
            </h2>
            
            <p className="text-lg text-slate-600 leading-relaxed mb-6">
              Túró István vagyok, a Turpa Build Kft. ügyvezető igazgatója. Mivel is segítem évtizedek óta megrendelőim?
            </p>
            
            <p className="text-lg text-slate-600 leading-relaxed mb-6">
              Több mint 20 éve vályog, vagy vegyes falazatú, illetve vert házak teljes körű javításával foglalkozom. Legyen ez aláfalazás, betonozás, vakolás, glettelés, bármi ami ehhez kapcsolódik.
            </p>
            
            <p className="text-lg text-slate-600 leading-relaxed mb-8">
              Öröm végezni ezt a munkát, hiszen megrendelőink elégedett mosolyát büszkén hordozza cégünk a szívében.
            </p>
            
            <button
              data-testid="founder-cta-btn"
              onClick={scrollToSurvey}
              className="bg-blue-900 text-white px-8 py-4 text-lg font-bold rounded-full hover:bg-blue-800 transition-all shadow-button hover:scale-105 active:scale-95"
            >
              Ingyenes felmérés
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FounderSection;
